/** Platform-neutral Connect handoff payload (Slice 2.10). */
export type ConnectHandoffSource = 'web' | 'ios' | 'android' | 'pwa'

export type ConnectHandoffPayload = {
  resumeRef: string
  source: ConnectHandoffSource
  returnPath: string
}

export const CONNECT_RESUME_RETURN_PATH = '/play/connect/resume' as const

export type ConnectHandoffAnalyticsEvent =
  | 'play_connect_link_opened'
  | 'play_connect_continue_clicked'
  | 'play_connect_resume_created'
  | 'play_connect_resume_attached'
  | 'play_connect_onboarding_resumed'
  | 'play_connect_completed'

export type ConnectResumeOutcome =
  | 'NO_PENDING_CONNECTION'
  | 'PENDING_CONNECTION_REQUIRES_DOG'
  | 'PENDING_CONNECTION_READY'
  | 'PENDING_CONNECTION_NO_LONGER_AVAILABLE'
  | 'PENDING_CONNECTION_SELF_ACCOUNT'

export type ConnectHandoffCompletionCode =
  | 'CONNECTED'
  | 'ALREADY_CONNECTED'
  | 'DECLINED'
  | 'CONNECTION_NO_LONGER_AVAILABLE'
  | 'EXPIRED_CONNECTION_LINK'
  | 'INVALID_CONNECTION_LINK'
  | 'NOT_PLAY_READY'
  | 'REQUIRES_DOG'
  | 'REQUIRES_SIGN_IN'
  | 'RESUME_ATTACH_FAILED'
  | 'ACCOUNT_MISMATCH'
  | 'SELF_CONNECTION'
